<template>
  <div class="content">
    <!-- <div class="breadcrumb">
      <i class="iconfont icondqwz"></i>
      <ul>
        <li class="active">内容管理</li>
      </ul>
    </div> -->
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i>内容管理
        </span>
        <div class="normalNav">
          <div class="buttonGroup">
            <div class="r">
              <slot></slot>
              <button class="GreenSmBtn" @click="addnews">新增</button>
              <button class="OrangeSmBtn" @click="reset">
                <span>重置</span>
              </button>
              <button class="BlueSmBtn" @click="search">搜索</button>
            </div>
          </div>
        </div>
        <div class="searchForm1">
          <el-form :model="nform" ref="nform">
            <el-form-item prop="stype">
              <el-select v-model="nform.stype">
                <el-option v-for="i of items" :key="i.value" :label="i.label" :value="i.label"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="tableWrapper" v-loading="!showTable">
          <!-- 后端分页 -->
          <section class="easyTable">
            <el-table
              :data="tabledata.list"
              class="stripeTable"
              stripe
              style="width: 100%"
              v-loading="bLoading"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
              ref="table_jsgl"
            >
              <el-table-column
                v-for="item of config"
                :key="item.prop"
                :label="item.label"
                :prop="item.prop"
                align="center"
              >
                <!-- <template slot-scope="scope">
                  <span v-if="item.prop === 'name'">{{scope.row.name}}</span>
                  <el-select
                    v-model="scope.row.sort"
                    v-else-if="item.prop === 'sort'"
                    @change="getSort(scope.row)"
                  >
                    <el-option v-for="i of tabledata.total" :key="i" :label="i" :value="i"></el-option>
                  </el-select>
                  <span v-else-if="item.prop === 'create_time'">{{scope.row.create_time}}</span>
                  <span v-else>{{scope.row.modify_time}}</span>
                </template>-->
              </el-table-column>
              <el-table-column label="操作" align="center" width="400">
                <template slot-scope="scope">
                  <el-link
                    :icon="scope.row.status ? 'iconfont iconcheck1' : 'iconfont icontingyong'"
                    type="text"
                    size="small"
                    @click="using(scope.row)"
                  >{{scope.row.status ? '启用' : '停用'}}</el-link>
                  <el-link
                    icon="iconfont iconedit"
                    type="text"
                    size="small"
                    @click="editcontent(scope.row)"
                  >修改</el-link>
                  <el-link
                    icon="iconfont iconyulan"
                    type="text"
                    size="small"
                    @click="apreview(scope.row,{edit:false})"
                  >预览</el-link>
                  <el-link
                    icon="iconfont icondel"
                    type="text"
                    size="small"
                    @click="tdelete(scope.row)"
                  >删除</el-link>
                </template>
              </el-table-column>
            </el-table>
            <div class="footer">
              <el-pagination
                layout="prev, pager, next"
                :total="tabledata.total"
                @current-change="handleCurrentChange"
              ></el-pagination>
            </div>
          </section>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-dialog
      :title="status === 1 ? '新增新闻' : '修改新闻'"
      :visible.sync="dialogVisible"
      class="editor"
      @close="closer"
    >
      <el-form :model="editorForm" ref="editorForm" label-position="right" label-width="100px">
          <el-form-item
            prop="newsTypeId"
            label="分类"
            :rules="[{required:true,message:'请选择新闻类型',trigger:'change'}]"
          >
            <el-select v-model="editorForm.newsTypeId">
              <el-option
                v-for="(item,index) of items"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            prop="title"
            label="标题"
            :rules="[{required:true,message:'请输入新闻标题',trigger:'blur'}]"
          >
            <el-input v-model="editorForm.title"></el-input>
          </el-form-item>
          <el-form-item prop="subtitle" label="副标题">
            <el-input v-model="editorForm.subtitle"></el-input>
          </el-form-item>
          <el-form-item
            prop="issuingTime"
            label="发表时间"
            :rules="[{required:true,message:'请选择发布时间',trigger:'change'}]"
          >
            <el-date-picker
              type="date"
              value-format="yyyy-MM-dd 00:00:00"
              format="yyyy 年 MM 月 dd 日"
              v-model="editorForm.issuingTime"
            ></el-date-picker>
          </el-form-item>
        <el-form-item prop="summary" label="摘要">
          <el-input type="textarea" v-model="editorForm.summary"></el-input>
        </el-form-item>
        <el-form-item label="封面图片">
          <el-upload
            ref="uploadImg"
            :action="action"
            list-type="picture-card"
            :on-success="fileSuccess"
            name="file"
            :file-list="fileList"
            :limit="1"
            :headers="headers"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>

        <el-form-item
          prop="content"
          label="内容"
          :rules="[{required:true,message:'请编写新闻',trigger:'blur'}]"
        >
          <vue-html5-editor
            class="html5editor"
            :height="600"
            :content="editorForm.content"
            @change="getContent"
            :show-module-name="showModuleName"
            ref="html5editor"
          ></vue-html5-editor>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" class="cancelButton">取 消</el-button>
        <el-button type="primary" @click="check" class="confirmButton">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog class="preview" :visible.sync="previewidalog">
      <div class="innerpreview">
        <h1 class="title" v-html="editorForm.title" :style="{fontSize:'23px',margin:'10px 0'}"></h1>
        <h3
          class="subtitle"
          v-html="editorForm.subtitle"
          :style="{fontSize:'18px',margin:'10px 0'}"
        ></h3>
        <p class="issuetime" v-html="editorForm.issuingTime" :style="{margin:'10px 0'}"></p>
        <div class="text" v-html="editorForm.content" style="color:#f5f5f5"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { dt, obj2urlsp } from "utils";
export default {
  data() {
    return {
      tabName: "jsgl",
      showTable: true,
      loading: false,
      dialogVisible: false,
      bLoading: true,
      previewidalog: false,
      showModuleName: false,
      previewhtml: "",
      items: [],
      action: "",
      fileList: [],
      headers: {
        authorization: localStorage.getItem("token"),
        userId: JSON.parse(localStorage.getItem("user")).id,
        companyId: localStorage.getItem("companyId")
      },
      nform: {
        stype: "",
        atype: ""
      },
      editorForm: {
        title: "",
        subtitle: "",
        newsTypeId: "",
        summary: "",
        issuingTime: "",
        status: 0,
        content: "",
        photoUrl: ""
      },
      pageNum: 1,
      pageSize: 10,
      tabledata: {},
      status: "",
      row: ""
    };
  },
  computed: {
    self() {
      return this;
    },
    config() {
      return [
        {
          prop: "title",
          label: "标题"
        },
        {
          prop: "summary",
          label: "摘要"
        },
        {
          prop: "newsTypeName",
          label: "新闻分类"
        },
        {
          prop: "issuingTime",
          label: "发表时间"
        }
      ];
    }
  },
  methods: {
    getContent(html) {
      this.editorForm.content = html;
    },

    fileSuccess(res, file, list) {
      this.editorForm.photoUrl = res.data;
    },
    // 重置
    reset() {
      this.$refs.nform.resetFields();
    },

    // 预览
    apreview(row, { edit }) {
      edit ? "" : (this.previewidalog = true);
      this.$axiosget(`operation/newsApi/findNewsInfo/${row.id}`).then(res => {
        let r = res.data.data;
        this.fileList = [];
        let obj = new Object();
        obj.url = process.env.API_HOST + r.photoUrl;
        this.fileList.push(obj);
        if (r) {
          for (let i in r) {
            if (i in this.editorForm) {
              this.editorForm[i] = r[i];
            }
          }
        }
      });
    },

    // 查询
    search() {
      this.getData();
    },

    // 关闭按钮
    closer() {
      this.html = "";
      for (let i in this.editorForm) {
        if (i !== "status") {
          this.editorForm[i] = "";
        }
      }
      this.$refs.uploadImg.clearFiles();
      this.$nextTick(() => {
        this.$refs.editorForm.clearValidate();
      });
    },

    // 新增按钮
    addnews() {
      this.status = 1;
      this.$nextTick(() => {
        this.dialogVisible = true;
      });
    },
    // 添加
    add() {
      this.$refs.editorForm.validate(valid => {
        if (valid) {
          if (!this.editorForm.photoUrl) {
            this.$notify({
              title: "请插入封面图片！",
              type: "warning"
            });
            return;
          } else {
            this.$axiospost("operation/newsApi/addNews", this.editorForm).then(
              res => {
                this.$message.success("添加成功");
                this.html = "";
                this.$nextTick(() => {
                  this.$refs.uploadImg.clearFiles();
                  this.$refs.editorForm.resetFields();
                  this.dialogVisible = false;
                });
                this.getData();
              }
            );
          }
        }
      });
    },
    // 翻页
    handleCurrentChange(value) {
      this.pageNum = value;
      this.getData();
    },
    // 列表数据
    getData() {
      this.$axiosget("operation/newsApi/findNewsPage", {
        params: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          newsTypeName: this.nform.stype
        }
      }).then(res => {
        this.tabledata = res.data.data;
        this.bLoading = false;
      });
    },
    // 新闻类型
    initNewsType() {
      this.$axiosget("operation/newsTypeApi/findNewsTypeList").then(res => {
        let r = res.data.data;
        for (let i = 0; i < r.length; i++) {
          let obj = {
            label: r[i].name,
            value: r[i].id
          };
          this.items.push(obj);
        }
      });
    },

    getSort(row) {

      this.$axiospost(
        `operation/newsTypeApi/updateNewsTypeSort/${row.id}`,
        {
          sort:row.sort
        }
      ).then(res => {
        this.getData();
      });
    },
    // 启停
    using(row) {
      this.$confirm(row.status ? "启用？" : "停用？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info"
      }).then(res => {
        let formdata = new FormData();
        formdata.append("id", row.id);
        formdata.append("status", row.status ? 0 : 1);
        // let obj = {
        //   id:row.id,
        //   status:row.status ? 0 : 1
        // }
        this.$axiospost(
          `operation/newsApi/updateNewsStatus/${row.id}`,
          formdata
        ).then(res => {
          this.$message.success("操作成功");
          this.getData();
        });
      });
    },

    editcontent(row) {
      this.row = row;
      this.status = 2;
      this.html = "";
      this.$nextTick(() => {
        this.dialogVisible = true;
        this.apreview(row, { edit: true });
      });
    },

    // 修改
    edit() {
      this.dialogVisible = true;
      this.$refs.editorForm.validate(valid => {
        if (valid) {
          if (!this.editorForm.photoUrl) {
            this.$notify({
              title: "请插入封面图片！",
              type: "warning"
            });
            return;
          } else {
            this.$axiospost("operation/newsApi/UpdateNews", {
              id: this.row.id,
              ...this.editorForm
            }).then(res => {
              this.$message.success("修改成功");
              this.$nextTick(() => {
                this.$refs.uploadImg.clearFiles();
                this.$refs.editorForm.resetFields();
                this.dialogVisible = false;
              });
              this.getData();
            });
          }
        }
      });
    },
    // 删除
    tdelete(row) {
      let formdata = new FormData();
      formdata.append("id", row.id);
      this.$confirm("删除此条新闻吗？", "警示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$axiospost(
          `operation/newsApi/deleteNews/${row.id}`,
          formdata
        ).then(res => {
          this.$message.success("删除成功");
          this.getData();
        });
      });
    },

    check() {
      switch (this.status) {
        case 1:
          this.add();
          break;
        case 2:
          this.edit();
          break;
      }
    }
  },
  components: {
    normalNav: () => import("public/normalNav"),
    searchForm: () => import("public/searchForm"),
    easyTable: () => import("public/easyTable")
  },
  mounted() {},
  created() {
    this.action = process.env.API_HOST + "zuul/operation/newsApi/addNewsPhoto";
    this.getData();
    this.initNewsType();
  }
};
</script>

<style scoped>
/deep/ .el-select {
  width: 100%;
}

/* .editor /deep/ .el-dialog .up {
  display: flex;
  justify-content: space-between;
} */
.editor /deep/ .el-dialog .el-form .el-form-item {
  flex: 1;
  margin-bottom: 15px !important;
}
.editor /deep/ .el-dialog .el-form .el-form-item__content .el-date-editor{
  width: 100%;
}

.editor /deep/ .el-dialog .el-form .el-form-item__content  .vue-html5-editor{
height: 350px;
}

.editor /deep/ .el-dialog .el-form .el-form-item__content {
  width: 80%;
  margin-left: 0 !important;
}
.editor /deep/ .el-dialog .up .el-form-item__content {
  width: auto;
}
.editor /deep/ .el-dialog .el-form .el-form-item label {
  color: #f5f5f5;
}
.editor /deep/ .el-dialog .el-form textarea,
.editor /deep/ .el-dialog .el-form .el-upload {
  background: transparent;
  border-color: rgba(255, 255, 255, 0.2);
  color: #f5f5f5;
}
.editor /deep/ .el-dialog .el-form .el-form-item__content input {
  border-color: rgba(255, 255, 255, 0.2);
  color: #f5f5f5;
}

.editor /deep/ .el-dialog .el-form .el-upload-list li {
  border: none;
}
.editor /deep/ .el-dialog .vue-html5-editor {
  background-color: transparent;
  border-color: rgba(255, 255, 255, 0.2);
}
.editor /deep/ .el-dialog .vue-html5-editor .toolbar ul {
  border-bottom-color: rgba(255, 255, 255, 0.2);
  color: #f5f5f5;
}
.editor /deep/ .el-dialog .vue-html5-editor .toolbar .dashboard {
  color: #f5f5f5;
  background-color: #181c2e;
}
.editor /deep/ .el-dialog .vue-html5-editor .content {
  margin-top: 0;
  /* background-color: #fff; */
  color: #f5f5f5;
}
.preview /deep/ .el-dialog__body .innerpreview {
  overflow: auto;
  background-color: transparent;
  padding: 10px;
}
.preview /deep/ .innerpreview .title,
.preview /deep/ .innerpreview .subtitle,
.preview /deep/ .innerpreview .issuetime {
  text-align: center;
  color: #f5f5f5;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/studyonline/subject/content.vue